import { i18n } from "@src/app/i18n";

const order_reason_dictionary: Record<string, string> = {
  item_damaged: i18n.global.t("Повреждён"),
  item_is_not_found: i18n.global.t("Нет на складе"),
};

export const getOrderReason = (reason: string) => order_reason_dictionary[reason] ?? "";
export const getOrderReasonList = () => Object.entries(order_reason_dictionary);
